/**
 * Application Configuration
 *
 * Configuration values and product information.
 */

export const config = {
  // API URL
  apiUrl: import.meta.env.VITE_API_URL || '/api',

  // Product Information
  product: {
    name: 'InvoSloth',
    version: '2.0.0',
    haciendaVersion: '4.4',
    description: 'Sistema de Facturación Electrónica',
  },

  // Creator Information
  creator: {
    name: 'WeCode Software Sloth',
    website: 'https://wecode.nasarca.dev/',
  },

  // Costa Rica Hacienda
  hacienda: {
    version: '4.4',
    country: 'Costa Rica',
  },
}

export default config
